module.exports = __webpack_public_path__ + "static/media/uon.b7fa8712.png";